<template>
    <div id="app">
        <router-view></router-view>
        <loading></loading>
        <div class="show" v-if="hasOpenModal"></div>
    </div>
</template>
<script>
import Loading from '@/components/Loading.vue';
import { anyModalOpen, installModalKeyboardHandling } from '@/plugins/modalStore';

export default {
    name: 'AppPage',
    data() {
        return {
        }
    },
    created() {
        this.loadMerchant();
        installModalKeyboardHandling();
    },
    components: { Loading },
    computed: {
        hasOpenModal() {
            return anyModalOpen();
        },
    },
    watch: {
        hasOpenModal(isOpen) {
            document.body.classList.toggle('modal-open', isOpen);
        },
    },
    methods: {
        loadMerchant() {
            this.$axios
                .get(`/admin/configuration`)
                .then(response => {
                    let body = {
                        name: response.data.data.name,
                        image: this.$baseUrl + response.data.data.image,
                        limit_per_page: response.data.data.enabled,
                        decimal_amount: response.data.data.identifier,
                        dollar_exchange_rate: response.data.data.decimal_amount,
                    };

                    localStorage.setItem("configuration", JSON.stringify(body));
                })
                .catch((e) => {
                    this.$store.commit("setErrors", e);
                });
        },
    }
}
</script>